"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withThemeInput } from "@/utils/withThemeInput";

const ShopTeaser = dynamic(
  async () => (await import("./ShopTeaser")).ShopTeaser
);

export const shopTeaserInputs = withThemeInput([
  {
    name: "title",
    type: "string",
    defaultValue: "Title",
    required: true,
  },
  {
    name: "isTitleHidden",
    friendlyName: "Hide title on bigger screens",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "topText", // change topText to bottomText once content migration is possible through migration scripts
    friendlyName: "Text on the bottom of card",
    type: "string",
  },
  {
    name: "href",
    type: "string",
    defaultValue: "/",
    required: true,
  },
  {
    name: "src",
    type: "file",
    allowedFileTypes: ["png, jpeg, jpg"],
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F546c651cab264950bb9f4d4520cd6ef9",
    required: true,
  },
  {
    name: "alt",
    friendlyName: "Image alt text",
    type: "string",
  },
  {
    name: "logoSrc",
    helperText: "Logo image",
    type: "file",
    allowedFileTypes: ["png, jpeg, jpg"],
  },
  {
    name: "isTopGradient",
    friendlyName: "With top gradient",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isBottomGradient",
    friendlyName: "With bottom gradient",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isLoyalty",
    type: "boolean",
    defaultValue: false,
  },
] as const satisfies Inputs);

export type ShopTeaserProps = BuilderComponentProps<typeof shopTeaserInputs>;

export const ShopTeaserComponent: RegisteredComponent = {
  name: "ShopTeaser",
  component: ShopTeaser,
  noWrap: true,
  inputs: shopTeaserInputs,
};
